/**<params config data>说明
 * position 控制文本框宽度位置
 */
import css from './index.module.scss';
import TextBanner from '@/components/ProductDetailComponents/TextBanner';
import { createEFPic } from '@/utils/useEFPic';
import Image from '@/components/UI/Image';

const item = {
    title: 'Battery Management System',
    synopsis: 'Performance plus safety.',
    desc: 'Confidence comes when you know your battery can take care of its own. The battery management system self regulates to keep your portable power station performing its best when it’s pushed to the limit.',
    bgImgs: '/img/rivermax2.png',
    footerNote: '',
    alt: '',
};
const configs = {
    position: 'left',
    margin: 'auto',
    padding: '0',
    zIndex: 2,
    opacity: 1,
    imageMarginTop: 0,
    isWebp: false,
};
export default function TextOnImage({ config, data = item }: any) {
    const configTypes = { ...configs, ...config };
    const { EFPic } = createEFPic(configTypes?.webpUrl);
    if (!configTypes.imgHeight) {
        configTypes.imgHeight = configTypes.position === 'left' || configTypes.position === 'right' ? '800px' : '1080px';
    }

    return (
        <div className={`${css.TextOnImage} TextOnImage ${configTypes?.cls}`}>
            <div className="box" key={data.title} style={{ height: configTypes.imgHeight }}>
                <div className="bg" style={{ height: configTypes.imgHeight, marginTop: configTypes.imageMarginTop }}>
                    {Array.isArray(data.bgImgs) || configTypes?.isWebp ? (
                        <EFPic name={data.bgImgs} className="fullImgs" alt={data.title ? data.title : data.synopsis} />
                    ) : (
                        <Image src={data.bgImgs} layout="fill" className="fullImgs" alt={data.title ? data.title : data.synopsis} />
                    )}
                </div>
                <div
                    className={
                        configTypes.position == 'top'
                            ? 'container topPosition'
                            : configTypes.position == 'left'
                            ? 'container leftPosition'
                            : configTypes.position == 'right'
                            ? 'container rightPosition'
                            : 'container bottomPosition'
                    }
                >
                    <div
                        style={{
                            width: configTypes.width
                                ? configTypes.width
                                : configTypes.position == 'left' || configTypes.position == 'right'
                                ? '550px'
                                : '924px',
                            zIndex: 2,
                        }}
                    >
                        <TextBanner config={configTypes} data={data} />
                        {!!data.footerNote && <div className="footerNote font-family-bold">{data.footerNote}</div>}
                    </div>
                </div>
            </div>
        </div>
    );
}
